module.exports = __webpack_public_path__ + "static/img/plem14.1907eaf.png";


//////////////////
// WEBPACK FOOTER
// ./static/plem14.png
// module id = xT94
// module chunks = 1